import { auth, db } from "@/service/firebase";
import store from "@/store/index";
import { onAuthStateChanged } from "firebase/auth";
import { doc, Timestamp, updateDoc } from "firebase/firestore";
import { COLLECTION_TOTEM } from "./collectionsNames";

// O gestão (tela de Manutenção) considera o totem ativo pelo `keep_alive` do
// doc do totem. Antes ele só era renovado durante uma compra, então um totem
// ligado e parado na Home parecia desligado.
const INTERVALO_KEEP_ALIVE = 60 * 1000;

let timer = null;

async function enviarKeepAlive() {
  const totemId = store.getters["totem/getToken"];
  if (!auth.currentUser || !totemId) return;
  try {
    // updateDoc, não setDoc: se o totem foi excluído o heartbeat não pode
    // recriar o documento.
    await updateDoc(doc(db, COLLECTION_TOTEM, totemId), {
      keep_alive: Timestamp.fromDate(new Date()),
    });
  } catch (err) {
    console.warn("Falha ao atualizar keep_alive do totem:", err);
  }
}

function parar() {
  if (timer) clearInterval(timer);
  timer = null;
}

function iniciar() {
  parar();
  enviarKeepAlive();
  timer = setInterval(enviarKeepAlive, INTERVALO_KEEP_ALIVE);
}

// Roda enquanto houver sessão: liga no login e desliga no logout.
export function iniciarKeepAliveTotem() {
  onAuthStateChanged(auth, (user) => {
    if (user) iniciar();
    else parar();
  });
  // O login termina antes do init gravar o token do totem no store; sem isto
  // o primeiro keep_alive só sairia um minuto depois do boot.
  store.watch(
    (state, getters) => getters["totem/getToken"],
    (token) => {
      if (token) enviarKeepAlive();
    }
  );
}
